import { Action } from 'redux';
import { User } from '../../models/user';

export enum UserActionTypes {
  ACTION_USER_CREATE = 'USER_CREATE',
}
export interface ActionUserCreate extends Action {
  type: UserActionTypes.ACTION_USER_CREATE;
  payload: User;
}

export type UserActions =
  | ActionUserCreate
  ;